import { AxiosError } from "axios";
import { ResponseGetClassroom } from "../classroom/interfaceClassroom";
import { deleteApi, getApi, patchApi, postApi, putApi } from "../CreateApi";
import { AscentCoverage, ProcessSettings, ResponseAvailable, ResponseGetEnrollment, StudentEligibility } from "./interfaceEnrollments";

export const getEnrollment = async (year?: string): Promise<ResponseGetEnrollment[]> => {
    try {
        const data = await getApi('/enrollment-schedule', { yearId: year });
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetEnrollment[];
    }
}

/** Cobertura de ascensos del año (origen) al siguiente. */
export const getAscentCoverage = async (yearId: string): Promise<AscentCoverage | { error: true; message: string }> => {
    try {
        return await getApi(`/enrollment/ascents/coverage/${yearId}`);
    } catch (error) {
        const axiosError = error as AxiosError<any>;
        return { error: true, message: axiosError?.response?.data?.message ?? "No se pudo cargar la cobertura de ascensos" };
    }
}

export const getStudentEligibility = async (studentId: number): Promise<StudentEligibility | undefined> => {
    try {
        return await getApi(`/enrollment/eligibility/${studentId}`);
    } catch (error) {
        return undefined
    }
}

export const getProcessSettings = async (year?: string): Promise<ProcessSettings | undefined> => {
    try {
        const data = await getApi(`/enrollment-schedule/settings/${year}`);
        return data
    } catch (error) {
        return undefined
    }
}

export const putProcessSettings = async (year: string, body: Partial<ProcessSettings>): Promise<any> => {
    try {
        const data = await putApi(`/enrollment-schedule/settings/${year}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postEnrollment = async (body: any): Promise<any> => {
    try {
        const data = await postApi('/enrollment-schedule', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}
export const getEnrollmentId = async (id?: number): Promise<ResponseGetEnrollment> => {
    try {
        const data = await getApi(`/enrollment-schedule/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetEnrollment;
    }
}

export const patchEnrollment = async (body: any, id?: number): Promise<any> => {
    try {
        const data = await patchApi(`/enrollment-schedule/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const deleteEnrollment = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/enrollment-schedule/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postEnrollmentAscent = async (body: any): Promise<any> => {
    try {
        const data = await postApi('/enrollment/config/ascent', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getEnrollmentAvailable = async (id: number): Promise<ResponseAvailable[]> => {
    try {
        const data = await getApi(`/enrollment/available/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseAvailable[];
    }
}

export const getEnrollmentAvailableTransfer = async (id: number, params?: {}): Promise<ResponseAvailable[]> => {
    try {
        const data = await getApi(`/enrollment/available-transfer/${id}`, params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseAvailable[];
    }
}

interface Props {
    studentId: number,
    activityClassroomId: number
}

export const postEnrollmentStundet = async (body: any): Promise<any> => {
    try {
        const data = await postApi('/enrollment', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const putDateExpiration = async (id: any, body: any): Promise<any> => {
    try {
        const data = await putApi(`/enrollment/update-expiration/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postTransfersStudentSection = async (body: any): Promise<any> => {
    try {
        const data = await postApi('/enrollment/refer-to-transfers', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const patchEnrollmentStundet = async (id: number, body: any): Promise<any> => {
    try {
        const data = await patchApi(`/enrollment/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

/** Cambia el aula de una prematrícula pendiente de pago (a una de las disponibles). */
export const patchEnrollmentClassroom = async (id: number, activityClassroomId: number): Promise<any> => {
    try {
        const data = await patchApi(`/enrollment/${id}/classroom`, { activityClassroomId });
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const resetSiagieByGrade = async (params: any): Promise<any> => {
    try {
        const query = new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "") as any
        ).toString();
        const data = await patchApi(`/enrollment/reset-siagie?${query}`, {});
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}